module.exports = __webpack_public_path__ + "static/img/saas1H5.a22233f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saas1H5.png
// module id = rqV9
// module chunks = 0